import { useRef, type ReactNode } from "react";

import { FormStoreContext, createFormStore } from "../../store/zustand-context";

interface FormProviderProps {
  children: ReactNode;
}

/**
 * FormProviderコンポーネント
 * フォームストアをコンテキスト経由で提供する
 *
 * このコンポーネントは、フォームファクトリー内の全コンポーネントに
 * フォームの状態とアクションへのアクセスを提供します。
 * 通常は直接使用せず、FormWrapperを介して使用します。
 */
export const FormProvider = ({ children }: FormProviderProps) => {
  // ストアインスタンスをuseRefで保持して、再レンダリング時に再作成されないようにする
  // createFormStoreはuseRefを使わないため、useRefの初期化関数内で安全に呼び出せる
  const storeRef = useRef(createFormStore());

  return (
    <FormStoreContext.Provider value={storeRef.current}>
      {children}
    </FormStoreContext.Provider>
  );
};
